<template>
	<div class="grid grid-cols-3 gap-x-8 xl:gap-x-24 gap-y-4 mt-4">
		<ProcessDocumentCardTabRow
			:document="customDocument"
			:dunning-status="dunningStatus"
			:is-edit-allowed="!isProcessFinished && isEditAllowed"
			:is-misc="true"
			v-if="evaluateMisc(customDocument)"
		/>

		<ProcessDocumentCardTabRow
			v-for="document in getDocuments"
			:key="document.id"
			:document="document"
			:dunning-status="dunningStatus"
			:is-edit-allowed="!isProcessFinished && isEditAllowed"
			:is-misc="evaluateMisc(document)"
		/>
	</div>
</template>
<script>
import ProcessDocumentCardTabRow from '@/views/management/Process/Document/ProcessDocumentCardTabRow';

export default {
	name: 'ProcessDocumentCardTab',
	components: { ProcessDocumentCardTabRow },
	props: {
		dunningStatus: {},
		documents: { required: true },
		isProcessFinished: {},
		isEditAllowed: { type: Boolean, default: true },
		title: { type: String, required: true },
		enableAddButton: { default: false },
		isSystemLawyer: { default: true },
	},
	data() {
		return {
			customDocument: { set: 'misc', type: 'misc', label: this.$t('upload_other_document') },
		};
	},
	computed: {
		isOrderDocumentation() {
			return this.process?.process_type === 'order_documentation';
		},
		process() {
			return this.$store.getters.getDamageCase;
		},
		getDocuments() {
			const documents = this.documents.filter(document => {
				if (!this.isSystemLawyer) {
					return document.type !== 'vollmacht-anwalt';
				}

				if (this.process.damageAssessor != null && this.process.damageAssessor.system_assessor) {
					return document.type !== 'damageassessor_documents';
				}

				if (this.isOrderDocumentation) {
					const forbiddenDocuments = [
						'polizeibericht',
						'rentalcar_contract',
						'rentalcar_contract_replacement_vehicle_return',
						'mietwagen-rechnung',
						'nebenleistungen',
					];
					return !forbiddenDocuments.some(type => document.type === type);
				} else if (this.$store.getters.isProcessComprehensive) {
					const forbiddenDocuments = [
						'rentalcar_contract',
						'rentalcar_contract_replacement_vehicle_return',
						'mietwagen-rechnung',
						'abfrage-gdv',
						'vorläufige-kalkulation (dat3 zip)',
						'wertminderung',
						'vorläufige-kalkulation',
						'damageassessor',
					];
					return !forbiddenDocuments.some(type => document.type === type);
				}

				return true;
			});

			return documents.sort((a, b) => a.label.localeCompare(b.label));
		},
	},
	methods: {
		evaluateMisc(document) {
			return this.enableAddButton || document.type === 'damageassessor_documents';
		},
		add() {
			this.$emit('add');
		},
		askFileName() {
			this.$swal({
				title: this.$t('file_name').toString(),
				text: this.$t('enter_file_name').toString(),
				icon: 'question',
				cancelButtonText: this.$t('general.cancel').toString(),
				showCancelButton: true,
				confirmButtonText: this.$t('upload').toString(),
				input: 'text',
				inputValue: this.$refs['file-upload'].uploadFileName
					.split('.')
					.slice(0, -1)
					.join('.'),
			}).then(result => {
				if (result.value) {
					this.$refs['file-upload'].triggerFileUpload(result.value);
				}
			});
		},
	},
};
</script>
